var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFireIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0907825 13.8515C0.637012 17.1603 3.60751 18.6625 5.02447 19C4.15816 18.1958 2.65021 15.8937 3.54884 13.119C4.44748 10.3444 6.39012 8.67422 7.24911 8.18594C4.76024 11.9127 6.39012 15.0578 7.97595 15.1655C9.24461 15.2517 9.45899 14.1818 9.4076 13.6361C11.7687 15.9626 10.4795 18.0378 9.53975 18.7846C15.7597 15.8549 14.1431 10.4981 12.5572 8.18594C12.7995 9.60771 11.5441 10.6848 10.3106 9.99546C9.07722 9.30612 9.53975 8.22902 9.73798 7.58277C9.93621 6.93651 10.3987 5.27778 9.53975 3.25283C8.85256 1.63288 7.15367 0.409297 6.39012 0C6.5443 2.17574 5.53106 3.64059 4.14346 5.27778C2.75586 6.91497 -0.592005 9.71542 0.0907825 13.8515Z",
    fill: "#FF5000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fire-icon.5416e2640e7b3c98e3b6d28fd53739db.svg";
export { ForwardRef as ReactComponent };